import React, { useEffect, useState } from 'react'
import { MonitorCheck, MonitorX } from 'lucide-react'
import { TableObjetosDepositados } from './TableObjetosDepositados'
import { TableObjetosRetirados } from './TableObjetosRetirados'
import { Tabs } from '../../AppComponents/Tabs'
import PointsCard from '../../AppComponents/PointsCard'
import { getPointsCurrentUser } from '../../Apis/intetcanviat/intercanviat'

export function Intercanviat({ language, userId }) {
    const tabs = [
        {
            label: language === 'castellano' ? 'Objetos depositados' : 'Objectes depositats',
            children: <TableObjetosDepositados language={language} userId={userId} />,
            icon: <MonitorCheck />,
        },
        {
            label: language === 'castellano' ? 'Objetos retirados' : 'Objectes retirats',
            children: <TableObjetosRetirados language={language} userId={userId} />,
            icon: <MonitorX />,
        },
    ]

    const [userPoints, setUserPoints] = useState(null)
    useEffect(() => {
        fetchPointsCurrentUser(userId)
    }, [userId])

    const fetchPointsCurrentUser = async (userId) => {
        const pointsUser = await getPointsCurrentUser(userId)
        console.log('Points User:', pointsUser)
        setUserPoints(pointsUser)
    }

    return (
        <div className="container mt-3">
            <div className="">
                <PointsCard language={language} userPoints={userPoints} />
            </div>
            <Tabs tabs={tabs} variant="boxed" />
        </div>
    )
}
